var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFivePlusBeds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.634 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.317 3.683c3.483 0 6.317 2.834 6.317 6.317s-2.834 6.317-6.317 6.317S1 13.483 1 10s2.834-6.317 6.317-6.317m0-1a7.317 7.317 0 100 14.634 7.317 7.317 0 000-14.634z",
    fill: "#2cb8c8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.698 9.896c.417.327.626.784.626 1.372 0 .366-.086.693-.257.981s-.428.515-.77.68-.762.247-1.26.247a3.7 3.7 0 01-1.282-.221c-.405-.146-.73-.343-.977-.589l.314-.514c.21.216.486.392.828.526.342.136.711.203 1.107.203.521 0 .925-.117 1.21-.352.285-.233.428-.546.428-.936 0-.432-.16-.759-.481-.981-.321-.222-.862-.333-1.624-.333H3.22l.324-3.158h3.447v.576h-2.88l-.216 2.009h.81c.912 0 1.576.164 1.993.49zM11.855 10.243h-1.674v1.638h-.568v-1.638H7.94v-.531h1.674V8.065h.567v1.647h1.674v.531z",
    fill: "#2cb8c8"
  })));
}

export default SvgIconFivePlusBeds;